import './authorizedUsers.js';
import './bidStatus.js';
import './bulkLoadCardStatus.js';
import './misc.js';
import './event-names.js';
import './eventsMapObj.js';
import './Faq.js';
import './languages.js';
import './loadStatus.js';
import './lorryStatus.js';
import './mostSearchedLinks.js';
import './Pages.js';
import 'react';
import './serviceTypeId.js';
import './StateList.js';
import './bidUpdateType.js';
import './userAction.js';
import './api.js';
import './link.js';
import './market.js';
import './payment.js';
import './admin/screenId.js';
import '../_services/const.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import { compareString } from '../methods/compareString.js';
import 'crypto-js';

const LORRY_CATEGORIES = {
    TRUCK: 1,
    LCV: 2,
    CONTAINER: 3,
    HYVA: 4,
    TRAILOR: 5,
    TANKER: 6
};
var LORRY_CATEGORIES_ENUM;
(function (LORRY_CATEGORIES_ENUM) {
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TRUCK"] = 1] = "TRUCK";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["LCV"] = 2] = "LCV";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["CONTAINER"] = 3] = "CONTAINER";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["HYVA"] = 4] = "HYVA";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TRAILER"] = 5] = "TRAILER";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TANKER"] = 6] = "TANKER";
})(LORRY_CATEGORIES_ENUM || (LORRY_CATEGORIES_ENUM = {}));
var LORRY_BODY_TYPE;
(function (LORRY_BODY_TYPE) {
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["OPEN"] = 0] = "OPEN";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["CLOSED"] = 1] = "CLOSED";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["METAL_STEEL"] = 2] = "METAL_STEEL";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["STAINLESS_STEEL"] = 3] = "STAINLESS_STEEL";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["OPEN_BODY"] = 4] = "OPEN_BODY";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["CLOSE_BODY"] = 5] = "CLOSE_BODY";
})(LORRY_BODY_TYPE || (LORRY_BODY_TYPE = {}));
//Need to be verified
const LORRY_BODY_TYPE_MAP = {
    0: "Open body",
    1: "Closed body",
    2: "Metal steel",
    3: "Stainless steel",
    4: "Open body",
    5: "Closed body"
};
var LORRY_CAPACITY_UNIT_TYPES;
(function (LORRY_CAPACITY_UNIT_TYPES) {
    LORRY_CAPACITY_UNIT_TYPES["TONNES"] = "Tonne(s)";
    LORRY_CAPACITY_UNIT_TYPES["KILO_LITRES"] = "Kilo Litre(s)";
    LORRY_CAPACITY_UNIT_TYPES["TONNE"] = "Tonne";
    LORRY_CAPACITY_UNIT_TYPES["KILO_LITRE"] = "Kilo Litre";
})(LORRY_CAPACITY_UNIT_TYPES || (LORRY_CAPACITY_UNIT_TYPES = {}));
const LorryNameToNumberMap = {
    Truck: LORRY_CATEGORIES.TRUCK,
    Trailor: LORRY_CATEGORIES.TRAILOR,
    Container: LORRY_CATEGORIES.CONTAINER,
    LCV: LORRY_CATEGORIES.LCV,
    Hyva: LORRY_CATEGORIES.HYVA,
    Tanker: LORRY_CATEGORIES.TANKER
};
var TRUCK_BODY_TYPES;
(function (TRUCK_BODY_TYPES) {
    TRUCK_BODY_TYPES[TRUCK_BODY_TYPES["OPEN"] = 0] = "OPEN";
    TRUCK_BODY_TYPES[TRUCK_BODY_TYPES["CLOSED"] = 1] = "CLOSED";
})(TRUCK_BODY_TYPES || (TRUCK_BODY_TYPES = {}));
/**
 * Internal use only
 */
var VehicleBodyOptionsType;
(function (VehicleBodyOptionsType) {
    VehicleBodyOptionsType[VehicleBodyOptionsType["OPEN"] = 10] = "OPEN";
    VehicleBodyOptionsType[VehicleBodyOptionsType["CLOSE"] = 11] = "CLOSE";
})(VehicleBodyOptionsType || (VehicleBodyOptionsType = {}));
const NEW_LORRY_TYPES = [
    {
        id: LORRY_CATEGORIES_ENUM.TRUCK,
        label: "Truck",
        iconRight: "Truck-right@3x.png",
        iconRightV2: "Truck-right-v2.png",
        iconLeft: "Truck-left@3x.png",
        fullIconRight: "lorry-icons/v2/Truck.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.CONTAINER,
        label: "Container",
        iconRight: "Container-right@3x.png",
        iconRightV2: "Container-right-v2.png",
        iconLeft: "Container-left@3x.png",
        fullIconRight: "lorry-icons/v2/Container.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TRAILER,
        label: "Trailer",
        iconRight: "Trailor-right@3x.png",
        iconRightV2: "Trailor-right-v2.png",
        iconLeft: "Trailor-left@3x.png",
        fullIconRight: "lorry-icons/v2/Trailer.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.LCV,
        label: "LCV",
        iconRight: "LCV-right@3x.png",
        iconRightV2: "LCV-right-v2.png",
        iconLeft: "LCV-left@3x.png",
        fullIconRight: "lorry-icons/v2/LCV.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN, VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.HYVA,
        label: "Hyva",
        iconRight: "Hyva-right@3x.png",
        iconRightV2: "Hyva-right-v2.png",
        iconLeft: "Hyva-left@3x.png",
        fullIconRight: "lorry-icons/v2/Hyva.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TANKER,
        label: "Tanker",
        iconRight: "Tanker-right@3x.png",
        iconRightV2: "Tanker-right-v2.png",
        iconLeft: "Tanker-left@3x.png",
        fullIconRight: "lorry-icons/v2/Tanker.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRE,
        unitShort: "KL",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    }
];
const VEHICLE_LIST = {
    LOAD_POST: [],
    LORRY_POST: []
};
const ALLOWED_LORRY_CATEGORY_IDS = [
    LORRY_CATEGORIES_ENUM.TRUCK,
    LORRY_CATEGORIES_ENUM.LCV,
    LORRY_CATEGORIES_ENUM.CONTAINER
];
const getAllowedVehicleList = (entityType, option) => {
    var _a;
    const listToFilter = (((_a = option === null || option === void 0 ? void 0 : option.srcList) === null || _a === void 0 ? void 0 : _a.length) ? option.srcList : undefined) ||
        (entityType === "load" ? VEHICLE_LIST.LOAD_POST : VEHICLE_LIST.LORRY_POST);
    return listToFilter.filter((lorry) => ALLOWED_LORRY_CATEGORY_IDS.some((id) => id === lorry.id));
};
const DefaultMinMax = { min: 0, max: 0 };
const NEW_LORRY_CAPACITY = {
    LOAD_POST: DefaultMinMax,
    LORRY_POST: DefaultMinMax
};
function calcCapacity(list) {
    return list.length
        ? list.reduce((range, lorry) => ({
            min: Math.min(range.min, lorry.capacity.min),
            max: Math.max(range.max, lorry.capacity.max)
        }), { min: Infinity, max: -Infinity })
        : DefaultMinMax;
}
const emptyLorryTypeBodyObject = Object.values(LORRY_CATEGORIES_ENUM)
    .filter((v) => typeof v === "number")
    .reduce((acc, key) => {
    acc[key] = {};
    return acc;
}, {});
const VehicleTypeBodyTypeMap = {
    load: emptyLorryTypeBodyObject,
    lorry: emptyLorryTypeBodyObject
};
function mapLorryListIntoBodyMap(list) {
    return list.reduce((acc, lorryInfo) => {
        const { id, bodyOptions } = lorryInfo;
        acc[id] = bodyOptions === null || bodyOptions === void 0 ? void 0 : bodyOptions.reduce((bodyAcc, bodyOption) => {
            bodyAcc[bodyOption.id] = bodyOption.name;
            return bodyAcc;
        }, {});
        return acc;
    }, {});
}
function generateLorryList(listForLoadPost, listForLorryPost) {
    const transformMethod = (lorry) => {
        var _a, _b, _c, _d, _e, _f;
        let min = Infinity;
        let max = -Infinity;
        // Collect min/max from tyre_capacity
        if (lorry.tyre_capacity) {
            for (const t of lorry.tyre_capacity) {
                min = Math.min(min, t.min);
                max = Math.max(max, t.max);
            }
        }
        // Collect min/max from feet_capacity
        if (lorry.feet_capacity) {
            for (const f of lorry.feet_capacity) {
                min = Math.min(min, f.min);
                max = Math.max(max, f.max);
            }
        }
        // If nothing found, fallback to 0
        if (min === Infinity)
            min = 0;
        if (max === -Infinity)
            max = 0;
        const bodyOptions = ((_a = lorry.body) === null || _a === void 0 ? void 0 : _a.map((item) => ({
            id: item.id,
            name: item.name
        }))) || [];
        const tyreOptions = ((_b = lorry.tyres) === null || _b === void 0 ? void 0 : _b.map((item) => ({
            count: item.count,
            text: item.text,
            label: `${item.count} ${item.text}`
        }))) || [];
        const tyreWithCapacity = ((_c = lorry.tyre_capacity) === null || _c === void 0 ? void 0 : _c.map((item) => ({
            min: item.min,
            max: item.max,
            tyreCount: item.tyres_count
        }))) || [];
        const feetOptions = ((_d = lorry.feet) === null || _d === void 0 ? void 0 : _d.map((item, ix) => ({
            id: ix + 1,
            label: `${item.size} ${item.type}`,
            size: item.size,
            sizeType: item.type
        }))) || [];
        const feetWithCapacity = ((_e = lorry.feet_capacity) === null || _e === void 0 ? void 0 : _e.map((item) => ({
            size: item.size,
            sizeType: item.type,
            min: item.min,
            max: item.max
        }))) || [];
        const feetWithTyres = ((_f = lorry.feet_tyre) === null || _f === void 0 ? void 0 : _f.map((item) => ({
            tyreCount: item === null || item === void 0 ? void 0 : item.tyres_count,
            feet: item === null || item === void 0 ? void 0 : item.feet
        }))) || [];
        return Object.assign(Object.assign({}, NEW_LORRY_TYPES.find((lr) => lr.id === (lorry === null || lorry === void 0 ? void 0 : lorry.id))), { remoteInfo: lorry, capacity: { min, max }, capacityText: `${min}-${max} ${lorry.capacity_unit}`, bodyOptions,
            tyreOptions,
            tyreWithCapacity,
            feetOptions,
            feetWithCapacity,
            feetWithTyres,
            getTyreOptionsByCapacity(capacity) {
                const validCapacities = tyreWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return tyreOptions.filter((t) => validCapacities.find((c) => c.tyreCount === t.count));
            },
            getSizeOptionsByCapacity(capacity) {
                const validCapacities = feetWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return feetOptions.filter((t) => validCapacities.find((c) => c.size === t.size && c.sizeType === t.sizeType));
            },
            getSizeOptionsByTyre(tyres) {
                var _a;
                const validSizeList = ((_a = feetWithTyres.find((item) => item.tyreCount === tyres)) === null || _a === void 0 ? void 0 : _a.feet) || [];
                return feetOptions.filter((t) => validSizeList.find((c) => c.size === t.size && c.type === t.sizeType));
            } });
    };
    const LOAD_POST_LIST = listForLoadPost.map(transformMethod);
    const LORRY_POST_LIST = listForLorryPost.map(transformMethod);
    return {
        LIST: {
            LOAD_POST: LOAD_POST_LIST,
            LORRY_POST: LORRY_POST_LIST
        },
        ALLOWED_CAPACITY: {
            LOAD_POST: calcCapacity(getAllowedVehicleList("load", {
                srcList: LOAD_POST_LIST
            })),
            LORRY_POST: calcCapacity(getAllowedVehicleList("lorry", {
                srcList: LORRY_POST_LIST
            }))
        },
        BODY_MAP: {
            load: mapLorryListIntoBodyMap(LOAD_POST_LIST),
            lorry: mapLorryListIntoBodyMap(LORRY_POST_LIST)
        }
    };
}
function initLorryList(listForLoadPost, listForLorryPost) {
    var _a, _b, _c, _d;
    const listMeta = generateLorryList(listForLoadPost, listForLorryPost);
    VEHICLE_LIST["LOAD_POST"] = listMeta.LIST.LOAD_POST;
    VEHICLE_LIST["LORRY_POST"] = listMeta.LIST.LORRY_POST;
    VehicleTypeBodyTypeMap["load"] = (_a = listMeta === null || listMeta === void 0 ? void 0 : listMeta.BODY_MAP) === null || _a === void 0 ? void 0 : _a.load;
    VehicleTypeBodyTypeMap["lorry"] = (_b = listMeta === null || listMeta === void 0 ? void 0 : listMeta.BODY_MAP) === null || _b === void 0 ? void 0 : _b.lorry;
    NEW_LORRY_CAPACITY["LOAD_POST"] = (_c = listMeta === null || listMeta === void 0 ? void 0 : listMeta.ALLOWED_CAPACITY) === null || _c === void 0 ? void 0 : _c.LOAD_POST;
    NEW_LORRY_CAPACITY["LORRY_POST"] = (_d = listMeta === null || listMeta === void 0 ? void 0 : listMeta.ALLOWED_CAPACITY) === null || _d === void 0 ? void 0 : _d.LORRY_POST;
}
const getLorryDetailsByType = (type) => {
    return NEW_LORRY_TYPES.find((lorry) => lorry.id === type);
};
const getLorryDetailsByName = (label) => {
    return NEW_LORRY_TYPES.find((lorry) => !!label && compareString(label, lorry === null || lorry === void 0 ? void 0 : lorry.label));
};
const getVehicleInfoByLorryType = (type, ...args) => {
    return getAllowedVehicleList(...args).find((lorry) => lorry.id === type);
};
const deriveVehicleBodyFilterValue = (type, bodyType) => {
    var _a;
    const bodyOption = (_a = getLorryDetailsByType(type)) === null || _a === void 0 ? void 0 : _a.bodyType;
    let result = null;
    if ((bodyOption === null || bodyOption === void 0 ? void 0 : bodyOption.length) === 1) {
        result = bodyOption[0];
    }
    else {
        if (type === LORRY_CATEGORIES_ENUM.LCV && Number.isInteger(bodyType)) {
            if (bodyType === LORRY_BODY_TYPE.OPEN_BODY) {
                result = VehicleBodyOptionsType.OPEN;
            }
            else if (bodyType === LORRY_BODY_TYPE.CLOSE_BODY) {
                result = VehicleBodyOptionsType.CLOSE;
            }
        }
    }
    return result;
};

export { ALLOWED_LORRY_CATEGORY_IDS, LORRY_BODY_TYPE, LORRY_BODY_TYPE_MAP, LORRY_CAPACITY_UNIT_TYPES, LORRY_CATEGORIES, LORRY_CATEGORIES_ENUM, LorryNameToNumberMap, NEW_LORRY_CAPACITY, TRUCK_BODY_TYPES, VehicleBodyOptionsType, VehicleTypeBodyTypeMap, deriveVehicleBodyFilterValue, generateLorryList, getAllowedVehicleList, getLorryDetailsByName, getLorryDetailsByType, getVehicleInfoByLorryType, initLorryList };
//# sourceMappingURL=lorryTypes.js.map
